import {CompetitorFieldDescriptor, CompetitorFormHelper} from "@model";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'visibleFields',
    standalone: false
})
export class VisibleFieldsPipe implements PipeTransform {
    transform(formHelper: CompetitorFormHelper): CompetitorFieldDescriptor[] {
        return formHelper.fields;
    }
}


